export default __webpack_public_path__ + "static/media/play.7e0d64cd.svg";